import { render } from "./TabInformationsPeople.vue?vue&type=template&id=24e52ba2&scoped=true"
import script from "./TabInformationsPeople.vue?vue&type=script&lang=js"
export * from "./TabInformationsPeople.vue?vue&type=script&lang=js"

import "./TabInformationsPeople.vue?vue&type=style&index=0&id=24e52ba2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e52ba2"]])

export default __exports__